import React, { createContext, useContext, useEffect } from "react";

import "../styles/wellperformance.css";

import "../styles/resizable.css";
import "../styles/grid-layout.css";
import { Layout, notification, Radio, Tooltip } from "antd";
import { CommandBar } from "@fluentui/react";

import { SubPageHeaderTitle } from "../../../../shared/SubPageHeaderTitle";

import { Select } from "antd";
import FlowstationProductionTrendStore from "../store/FlowstationProductionTrendStore";
import { Observer, observer } from "mobx-react-lite";

import { Responsive, WidthProvider } from "react-grid-layout";

import MainStore from "../../../home/store/mainStore";
import { ProductionTrendChart } from "./ProductionTrendChart";
import { CummulativeTrendChart } from "./CummulativeTrendChart";
import { APIChart } from "./APIChart";

const { Content } = Layout;
const ResponsiveGridLayout = WidthProvider(Responsive);

const flowstationProductionTrendStoreCtx = createContext(
  FlowstationProductionTrendStore
);

const { Option } = Select;

const mainStoreCtx = createContext(MainStore);
export const FlowStationprodTrendBaseView = observer(() => {
  const flowstationProductionTrendStore = useContext(
    flowstationProductionTrendStoreCtx
  );
  const mainStore = useContext(mainStoreCtx);

  useEffect(() => {
    async function loadUniqueFlowstationData() {
      try {
        await flowstationProductionTrendStore.getuniqueFlowstationsData();
        const fId =
          flowstationProductionTrendStore.selectedFlowstation.flowstationId;
        await flowstationProductionTrendStore.getFlowstationPlotData(fId);
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
    }
    loadUniqueFlowstationData();
    mainStore.resetAssetContext();
  }, []);

  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #87d068",
      }}
    >
      <Content>
        {" "}
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  {
                    key: "1",
                    onRender: () => (
                      <div style={{ paddingTop: "5px" }}>
                        <Observer>
                          {() => (
                            <SubPageHeaderTitle
                              title={`${flowstationProductionTrendStore.selectedFlowstation.flowsationName} Production Trend`}
                            />
                          )}
                        </Observer>
                      </div>
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "5",
                    onRender: () => (
                      <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm7">
                            Select Flowstation
                          </div>
                          <div className="ms-Grid-col ms-sm7">
                            {
                              <Observer>
                                {() => (
                                  <Select
                                    showSearch
                                    style={{ width: 300 }}
                                    placeholder="Select a Flowstation"
                                    value={
                                      flowstationProductionTrendStore
                                        .selectedFlowstation.flowsationName
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children.indexOf(
                                        input.toLowerCase()
                                      ) >= 0
                                    }
                                    onChange={async (value, obj) => {
                                      console.log(value, obj);
                                      flowstationProductionTrendStore.selectedFlowstation =
                                        {
                                          flowstationId: obj.value,
                                          flowsationName: obj.children,
                                        };
                                      await flowstationProductionTrendStore.getFlowstationPlotData(
                                        value
                                      );
                                    }}
                                  >
                                    {flowstationProductionTrendStore.uniqueFlowstations.map(
                                      (flowstation) => (
                                        <Option
                                          value={flowstation.flowstationId}
                                          key={flowstation.flowstationId}
                                        >
                                          {flowstation.flowstationName}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                )}
                              </Observer>
                            }
                          </div>
                        </div>
                      </div>
                    ),
                  },
                ]}
              ></CommandBar>
            </div>
          </div>
          <div
            className="ms-Grid-row"
            style={{
              marginTop: "5px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          ></div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ResponsiveGridLayout
                className="layout"
                draggableCancel=".chart-container-control, .chart-container-controls, .highcharts-container, .highcharts-contextmenu, .highcharts-menu"
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                rowHeight={100}
              >
                <div
                  key="1"
                  data-grid={{ x: 0, y: 0, w: 12, h: 4 }}
                  className=" ms-motion-fadeIn"
                >
                  <ProductionTrendChart />
                </div>
                <div
                  key="4"
                  data-grid={{ x: 0, y: 1, w: 12, h: 4 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <CummulativeTrendChart />
                </div>
                <div
                  key="5"
                  data-grid={{ x: 0, y: 2, w: 12, h: 4 }}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <APIChart />
                </div>
              </ResponsiveGridLayout>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

